import React, { useEffect } from 'react';
import styles from "./Search.module.css";

const Search = ({
  special,
  cathedra,
  handleFilter,
  filter,
  handleGetInfo,
  groups,
  scy,
  schema,
  period,
  trashReport,
  trashSchema,
  trashCafedra,
  trashGroup,
  trashPortrait,
  trashCalcAnswer,
  trashCalculation,
  military_profs
}) => {
  useEffect(() => {
    trashReport();
    trashPortrait();
    trashCalcAnswer();
    trashCalculation();
  }, []);

  return (
    <div className={styles.popupWrapper}>
      <div className={styles.popup}>
        <div className={styles.selectBlockWrapper}>
          <div className={styles.selectBlockOuter}>
            <div className={styles.selectBlock}>
              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '140px' }}>Учебный год</span>
                <select
                  className={styles.select}
                  value={filter.y}
                  onChange={(e) => handleFilter(e.target.value, 'y')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(scy) && [...scy].reverse().map(item => (
                    <option key={item.xp_key} value={item.xp_key}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '176px' }}>Военная специальность</span>
                <select
                  className={styles.select}
                  value={filter.mpid}
                  onChange={(e) => handleFilter(e.target.value, 'mpid')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(military_profs) && military_profs.map(item => (
                    <option key={item.mpid} value={item.mpid}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              

              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '140px' }}>Схема</span>
                <select
                  className={styles.select}
                  value={filter.s}
                  onChange={(e) => handleFilter(e.target.value, 's')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(schema) && schema.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              </div>
              

            <div className={styles.selectBlock}>
              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '140px' }}>Факультет</span>
                <select
                  className={styles.select}
                  value={filter.f}
                  onChange={(e) => handleFilter(e.target.value, 'f')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(special) && special.map(item => (
                    <option key={item.idfaculty} value={item.idfaculty}>
                      {item.faculty}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '176px' }}>Группа</span>
                <select
                  className={styles.select}
                  value={filter.g}
                  onChange={(e) => handleFilter(e.target.value, 'g')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(groups) && groups.map(item => (
                    <option key={item.gid} value={item.gid}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.inputWrapper}>
                <span className={styles.inputTitle} style={{ width: '140px' }}>Месяц</span>
                <select
                  className={styles.select}
                  value={filter.p}
                  onChange={(e) => handleFilter(e.target.value, 'p')}
                >
                  <option value="">Выбрать</option>
                  {Array.isArray(period) && period.map(item => (
                    <option key={item.trmid} value={item.trmid}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              
            </div>
          </div>

          <div
            className={styles.button}
            onClick={handleGetInfo}
          >
            Применить
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
